import messages from '../messages';

export const getPaymentMethodDescriptionMessage = (paymentMethod: string) => {
  switch (paymentMethod) {
    case 'cb2x':
      return messages.cb2xDescription;
    case 'cb3x':
      return messages.cb3xDescription;
    case 'cb4x':
      return messages.cb4xDescription;
    case 'bancontact':
      return messages.bancontactDescription;
    case 'paybylink':
      return messages.paybylinkDescription;
    case 'sepa':
      return messages.sepaDescription;

    default:
      return undefined;
  }
};
